module.exports = __webpack_public_path__ + "img/ucuz.fe1641b4.png";